import $ from 'jquery';
import 'slick-carousel';

const QuoteSlider = () => {

	let quoteCarousel = $('.quote-slider__slides--active');

	quoteCarousel.slick({
		adaptiveHeight: true,
		lazyLoad: 'ondemand',
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		dotsClass: 'quote-slider__dots',
		accessibility: false,
		mouseDrag: true,
		fade: true,
		prevArrow: '.quote-slider__arrow--prev',
		nextArrow: '.quote-slider__arrow--next',
	});

};

export default QuoteSlider;